export default __webpack_public_path__ + "static/media/tissue-rolling2.2175fa84.svg";